// /* eslint-disable */ 
import './blocks/scripts/product';
